.root {
  --switch-height: var(--selection-control-size-md);
  --switch-inset: var(--control-border-width);
  box-sizing: border-box;
  height: var(--switch-height);
  width: calc(var(--switch-height) * 5 / 3);
  border-width: var(--control-border-width);
  border-style: solid;
  padding: var(--switch-inset);
  cursor: pointer;

  &[aria-invalid="true"] {
    border-color: var(--color-danger-border);

    &:not([data-disabled]):is(:hover, :focus-visible) {
      border-color: var(--color-danger);
    }

    &:not([data-disabled]):hover {
      background-color: var(--color-danger-soft-opaque);

      &[data-checked] {
        background-color: var(--color-danger);
      }
    }
  }

  &[data-disabled] {
    border-style: dashed;
    cursor: not-allowed;
  }

  &[data-size="lg"] {
    --switch-height: var(--selection-control-size-lg);
  }

  &[data-size="sm"] {
    --switch-height: var(--selection-control-size-sm);
  }
}

.thumb {
  width: calc(var(--switch-height) - 2 * var(--control-border-width) - 2 * var(--switch-inset));

  &[data-checked] {
    transform: translateX(calc(var(--switch-height) * 2 / 3 * var(--inline-sign)));
  }
}
